var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.firstPartOfSearchString)),_c('span',{staticClass:"bold-text"},[_vm._v(_vm._s(_vm.highlightedSearch))]),_vm._v(_vm._s(_vm.secondPartOfSearchString)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }